export const allowedMxpQueryParams = ['cta', 'query', 'page', 'filter', 'webview'];
